import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import { MultiButton } from 'view/components/buttons'

export const ASSET_COLOURS = [constants.ASSET_COLOUR1, constants.ASSET_COLOUR2, constants.ASSET_COLOUR3, constants.ASSET_COLOUR4]
export const COUNTERPARTY_COLOURS = [constants.COUNTERPARTY_COLOUR1, constants.COUNTERPARTY_COLOUR2, constants.COUNTERPARTY_COLOUR3]

export enum BorderColourType {
  None,
  Asset,
  Counterparty
}

export const getBorderColour = (borderColourType: BorderColourType, index: number) => {
  switch (borderColourType) {
    case BorderColourType.None: {
      return 'grey'
    }
    case BorderColourType.Counterparty: {
      if (index === undefined) {
        return 'grey'
      }
      return COUNTERPARTY_COLOURS[index % COUNTERPARTY_COLOURS.length]
    }
    case BorderColourType.Asset: {
      if (index === undefined) {
        return 'grey'
      }
      return ASSET_COLOURS[index % ASSET_COLOURS.length]
    }
    default: {
      throw new Error(`Unhandled BorderColorType ${BorderColourType[borderColourType]}`)
    }
  }
}

export const ListContainer = styled.ol`
  margin-top: 4px;
  border: 1px solid ${constants.CORE_PRIMARY_2};
  border-radius: 6px;
`

export const ListItem = styled.li<{ borderColourType: BorderColourType; index: number }>`
  ${mixins.flexCenterContentCrossAxis};
  width: 100%;
  border-bottom: 1px solid #e1e3e7;
  justify-content: space-between;
  border-left: 6px solid ${props => getBorderColour(props.borderColourType, props.index)};
  padding-right: 5px;
  &:only-child {
    border-top: none;
    border-bottom: none;
  }
  &:first-of-type {
    border-top: none;
    border-top-left-radius: 6px;
  }
  &:last-child {
    border-bottom: none;
    border-bottom-left-radius: 6px;
  }
`

export const ItemLabelContainer = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  padding-left: 6px;
  font-size: 12px;
  height: 100%;
  overflow: hidden;
`

export const RemoveItemButton = styled(MultiButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  svg {
    width: 8px;
    height: 8px;
  }
  &:hover {
    svg {
      color: red;
    }
  }
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-width: 425px;
  max-width: 425px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const ButtonsSection = styled.div`
  width: 100%;
  padding: 12px;
`

export const RFQPrepareContainer = styled.div`
  width: 100%;
  flex: 1 1 auto;
  background-color: white;
  overflow-y: auto;
  & > *:not(:last-child) {
    margin-bottom: 2px;
  }
`
